import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Spinner from '../common/Spinner';
import Button from '../common/Button';
import { useNavigate } from 'react-router-dom';

const AvailableTrips = () => {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/trips')
      .then(res => setTrips(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  return (
    <div className="glass-card fade-in">
      <h2>Available Trips</h2>
      <div className="trip-grid">
        {trips.map(trip => (
          <div key={trip.id} className="trip-card">
            <h3>{trip.plate_number}</h3>
            <p>{trip.route_from} → {trip.route_to}</p>
            <p>Departure: {new Date(trip.departure_time).toLocaleString()}</p>
            <Button onClick={() => navigate(`/passenger/pay/${trip.id}`)}>Pay</Button>
          </div>
        ))}
        {trips.length === 0 && <p>No trips available right now.</p>}
      </div>
      <style>{`
        .trip-grid {
          display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 1rem; margin-top: 1rem;
        }
        .trip-card {
          background: white; padding: 1.25rem; border-radius: var(--radius-md); box-shadow: var(--shadow-sm);
        }
        .trip-card h3 { color: var(--primary); margin-bottom: 0.5rem; }
      `}</style>
    </div>
  );
};
export default AvailableTrips;